import ReactDOM from "react-dom";
import React from "react";

ReactDOM.render(<div>Working!</div>, document.querySelector("#root"));
